import {
  GET_RRHH_REQUEST,
  GET_RRHH_SUCCESS,
  GET_RRHH_FAILURE,
  RESET_RRHH,
} from '../../constants/rrhh/rrhh.constants';

export const getRrhhAction = (page, start, limit, sede, tipoListado,
  busqueda = null, rrhhSeleccionados = []) => ({
  type: GET_RRHH_REQUEST,
  payload: {
    page, start, limit, sede, tipoListado, busqueda, rrhhSeleccionados,
  },
});

export const getRrhhSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_RRHH_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getRrhhFailureAction = error => ({
  type: GET_RRHH_FAILURE,
  payload: error,
});

export const resetRrhh = () => ({
  type: RESET_RRHH,
});
